import { IdNamePair, PolicyHolder } from "@/shared/domain";

export const MAX_POLICYHOLDERS = 3;

export const mapPolicyholderDropdownOption = (policyholders: PolicyHolder[] = []): IdNamePair<number>[] =>
    policyholders.map((policyholder) => ({
        id: policyholder.policyHolderId,
        name: policyholder.fullName,
    }));
